import { icons } from "assets";
import { Header } from "Components/header/Header";
import SettingsCard from "Components/shared/cards/SettingsCard";
import Text from "Components/shared/text";
import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./history.module.css";

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.root}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Text variant="xl" tag="h1" style={{ fontWeight: "700" }}>
            Transaction History
          </Text>
          <Text variant="sm" color="secondary">
            View all your transaction history in one place
          </Text>
        </div>
        <Header hidden />
      </div>

      <div className={styles.Menu}>
        <SettingsCard
          icon={<img src={icons.naira_wallet} alt="wallet icon" />}
          text="Naira Wallet Transaction"
          action={() => startTransition(() => navigate("naira-wallet"))}
        />
        <SettingsCard
          icon={<img src={icons.exchange} alt="currency swap icon" />}
          text="Currency Swap Transactions"
          action={() => startTransition(() => navigate("currency-swap"))}
        />
        <SettingsCard
          icon={<img src={icons.transfers} alt="transfer icon" />}
          text="Transfer Transactions"
          action={() =>
            startTransition(() => navigate("transfer-transactions"))
          }
        />
        <SettingsCard
          icon={<img src={icons.credit_card} alt="debit icon" />}
          text="Debit card Transaction"
          action={() =>
            startTransition(() => navigate("debit-card-transactions"))
          }
        />
      </div>
    </div>
  );
};

export default Home;
